import React from 'react';
import { useState, useEffect } from 'react';
import {
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Button, Modal, Col, Spinner,
  FormGroup, Label, Input, NavLink, ModalBody, ModalFooter
} from "reactstrap";
import { Form, Field } from "react-final-form";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
import iconSet from "selection.json";
import IcomoonReact, { iconList } from "icomoon-react";
import dataProvider from "dataProvider";
import { useHistory } from "react-router-dom";
import auth from "authProvider";
import decodeJwt from 'jwt-decode';


const Users = (props) => {
  const [users, setUsers] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [roles, setRoles] = useState(false);
  const [selectedrole, setSelectedrole] = useState(false);
  const [pos, setPos] = useState(false);
  const [flag, setFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [confirmOpen, setConfirmOpen] = useState({ visible: false, id: null, index: null });
  const [page, setPage] = useState(1);
  const [more, setMore] = useState(true);
  const [reload, setReload] = useState(false);
  const [sucess, setSucess] = useState(false);
  const [view_open, setview_Open] = useState(false);
  const [peropen, setPeropen] = useState(false)
  // const [visibility,setVisibility] = useState(false)

  const history = useHistory();

  const onLogout = () => {
    auth.logout();
    history.push("/")
  }

  const handleClickOpen = (index) => {
    setPos(index)
    setOpen(true);
    setRoles(users[index].role)
  };
  const handleClose = () => {
    setOpen(false);
  };
  const Closeconfirm = () => {
    setConfirmOpen({ visible: false, id: null, index: null });
  };

  useEffect(() => {
    let token = localStorage.getItem('token');
    dataProvider.getList('users', { params: { pagination: { page: page, perPage: 20 }, sort: { order: 'desc', field: 'id' }, filter: {}, token: token } })
      .then(({ data }) => {
        if (data.length < 20) {
          setMore(false)
        }
        else {
          setMore(true)
        }
        setUsers(data);
      })
      .catch(error => {
        // console.log(error?.response?.data?.expire)
        if (error?.response?.data?.expire === true) {
          setModalOpen(true)
        }
      });
    dataProvider.getList('role', { params: { pagination: { page: 1, perPage: 20 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => {
        setRoles(data);
        if (data.length > 0) {
          setSelectedOption(data[0].id)
        }
      })
      .catch(error => {
      });
  }, [props, reload]);

  const onSubmit = (values, id) => {
    setOpen(false);
    setLoading(true)
    dataProvider.update('users', { id: users[pos].id, params: { ...values, role: selectedrole } })
      .then(({ data }) => {
        setLoading(false)
        setSucess(true)
        setTimeout(() => Push(), 1000);
        history.push("/users");
      })
      .catch(error => {
      });
  };
  const removeData = (id, index) => {
    dataProvider.delete('users', { id: id });
    let userArr = users;
    userArr.splice(index, 1);
    setUsers(userArr);
    setFlag(!flag)
    setConfirmOpen({ visible: false, id: null, index: null });
  }
  const onPagination = (i) => {
    let newPage = page + i;
    if (newPage == 0) {
      return;
    }
    else if (i === 1 && !more) {
      return;
    }
    setPage(newPage);
    setReload(!reload);
  }
  const Push = () => {
    setSucess(false)

  }
  const viewopen = (index) => {
    setPos(index)
    setview_Open(true);
    setRoles(users[index].role)

  }
  const viewClose = () => {
    setview_Open(false);
  };
  let per = localStorage.getItem('permission');
  // let token = localStorage.getItem('token');
  // const decodedToken = decodeJwt(token);
  // const per = decodedToken.user.permissions;

  const perModal = () => {
    setPeropen(true)
  }
  const permodalClose = () => {
    setPeropen(false)
  }
  if (!users) {
    return (
      <>
        <div >
          <td style={{ color: '#12ACF6', position: "fixed", top: "50%", left: "55%", transform: "translate(-50%, -50%)" }} colSpan={11}><Spinner /></td>
        </div>
      </>
    )
  }

  return (
    <>
      <div className="header pb-8 pt-5 pt-md-6" style={{
        width: '100%',
        backgroundImage:
          "url(" +
          require("../../../assets/img/brand/header.jpg").default +
          ")",
      }}>
        <Container fluid >
          <div className="header-body">
            {/* header*/}
            <Row style={{ color: 'white', fontSize: '1.25rem', paddingLeft: '20px', flexDirection: 'row', justifyContent: 'space-between' }}>
              <h1 className="mb-0" style={{ color: 'white', alignContent: 'flex-start' }}>USERS</h1>
              <div style={{ alignContent: 'flex-end', marginRight: '20px' }}>
                {per.includes('users_add') ? <Link to="/users/create"><Button style={{ backgroundColor: 'white', fontSize: '0.625rem', padding: '10px', borderRadius: '30px', color: '#0C6C9A', marginRight: 10 }} ><IcomoonReact iconSet={iconSet} color="#0C6C9A" size={14} icon="add" /> CREATE USER</Button></Link> :
                  <Button onClick={() => perModal()} style={{ backgroundColor: 'white', fontSize: '0.625rem', padding: '10px', borderRadius: '30px', color: '#0C6C9A', marginRight: 10 }}><IcomoonReact iconSet={iconSet} color="#0C6C9A" size={14} icon="add" /> CREATE USER</Button>}
                {per.includes('tenants_add') ? <Link to="/tenants/create"><Button style={{ backgroundColor: 'rgb(219 219 147)', fontSize: '0.625rem', padding: '10px', borderRadius: '30px', color: '#0C6C9A', border: 0 }} ><IcomoonReact iconSet={iconSet} color="#0C6C9A" size={14} icon="add" /> CREATE TENANT</Button>{' '}</Link> :
                  <Button onClick={() => perModal()} style={{ backgroundColor: 'rgb(219 219 147)', fontSize: '0.625rem', padding: '10px', borderRadius: '30px', color: '#0C6C9A', border: 0 }} ><IcomoonReact iconSet={iconSet} color="#0C6C9A" size={14} icon="add" /> CREATE TENANT</Button>}
                {/* <Link to="/tenants/create"><Button style={{ backgroundColor: 'rgb(219 219 147)', fontSize: '0.625rem', padding: '10px', borderRadius: '30px', border: 0, color: '#0C6C9A' }}><IcomoonReact iconSet={iconSet} color="#0C6C9A" size={14} icon="add" /> CREATE TENANT</Button>{' '}</Link> */}
              </div>
            </Row>
          </div>
        </Container>
      </div>

      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0" style={{ display: 'flex', color: 'white', fontSize: '1.25rem', paddingLeft: '20px', flexDirection: 'row', justifyContent: 'space-between' }} >
                <div style={{ alignContent: 'flex-start' }}><h3 className="mb-0">ADMIN LIST</h3></div>
                <div style={{ alignContent: 'flex-end' }}>
                  {page > 1 || page !== 1 ? <Button onClick={() => onPagination(-1)} style={{ backgroundColor: 'white', fontSize: '0.75rem', height: '2.5rem', padding: '0px', color: '#77665c', width: '5rem', margin: '0px', borderColor: 'rgb(144 151 153)' }} >
                    <IcomoonReact style={{ paddingRight: 5 }} iconSet={iconSet} color="#77665c" size={11} icon="prev" />PREV</Button>
                    : <Button disabled style={{ backgroundColor: 'white', fontSize: '0.7rem', height: '2.5rem', padding: '0px', color: '#77665c', width: '5rem', margin: '0px', borderColor: '#ccc' }} >
                      <IcomoonReact style={{ paddingRight: 5 }} iconSet={iconSet} color="#77665c" size={10} icon="prev" />PREV</Button>}
                  {more ? <Button onClick={() => onPagination(1)} style={{ backgroundColor: 'white', fontSize: '0.75rem', borderColor: '#ccc', padding: '0px', height: '2.5rem', color: '#77665c', width: '5rem', borderColor: 'rgb(144 151 153)' }} > NEXT
                    <IcomoonReact style={{ paddingLeft: 5 }} iconSet={iconSet} color="#77665c" size={11} icon="next" /></Button> :
                    <Button disabled style={{ backgroundColor: 'white', fontSize: '0.7rem', borderColor: '#ccc', padding: '0px', height: '2.5rem', color: '#77665c', width: '5rem', borderColor: '#ccc' }} > NEXT
                      <IcomoonReact style={{ paddingLeft: 5 }} iconSet={iconSet} color="#77665c" size={10} icon="next" /></Button>}
                </div>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">
                      <FormGroup check style={{ paddingBottom: '20px' }}>
                        <Input type="checkbox" />{' '}
                      </FormGroup>
                    </th>
                    <th scope="col">User</th>
                    <th scope="col" >Email</th>
                    <th scope="col">USER NAME</th>
                    <th scope="col" style={{ paddingLeft: 10 }}>PHONENUMBER</th>
                    <th scope="col">PERMISSION</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  {users && users.length > 0 && users.map((item, index) => (
                    <tr>
                      <th>
                        <FormGroup check style={{ paddingBottom: '20px' }}>
                          <Input type="checkbox" />{' '}
                        </FormGroup>
                      </th>
                      <td style={{ color: '#12ACF6', textTransform: 'capitalize' }}>{item.full_name}</td>
                      <td>{item.email}</td>
                      <td>{item.username}</td>
                      <td>{item.phone}</td>
                      <td>
                        <Link to={{ pathname: "/users/permission/", state: item.id }}><Button style={{ backgroundColor: 'rgb(219 219 147)', fontSize: '0.625rem', padding: '10px', borderRadius: '30px', border: 0 }}>Permission</Button>{' '}
                        </Link>
                      </td>
                      <td style={{ flexDirection: 'row', display: 'flex' }}>
                        <Button style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }}
                          onClick={() => viewopen(index)}>
                          <IcomoonReact iconSet={iconSet} color="#ccc" size={18} icon="view" />
                        </Button>
                        {per.includes('users_edit') ? <Button style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }}
                          onClick={() => handleClickOpen(index)}>
                          <IcomoonReact iconSet={iconSet} color="#ccc" size={16} icon="edit" />
                        </Button> : <Button style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }}
                          onClick={() => perModal()}>
                          <IcomoonReact iconSet={iconSet} color="#ccc" size={16} icon="edit" />
                        </Button>}
                        <NavLink id="nav-link">
                          {per.includes('users_delete') ? <Button style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }} onClick={() => setConfirmOpen({ visible: true, id: item.id, index: index })} >
                            <IcomoonReact iconSet={iconSet} color="#ccc" size={20} icon="delete" />
                          </Button> :
                            <Button onClick={() => perModal()} style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }}  >
                              <IcomoonReact iconSet={iconSet} color="#ccc" size={20} icon="delete" />
                            </Button>}
                        </NavLink>
                      </td>
                    </tr>
                  )
                  )}
                </tbody>
              </Table>
              <Modal isOpen={confirmOpen.visible} size="sm">
                <ModalBody style={{ color: 'red' }}>Are you sure want to delete this user?</ModalBody>
                <ModalFooter>
                  <Button onClick={Closeconfirm} style={{ color: 'white', backgroundColor: 'rgb(5 160 187)', border: 0 }} type="button">
                    cancel
                  </Button>
                  <Button onClick={() => removeData(confirmOpen.id, confirmOpen.index)} style={{ color: 'white', backgroundColor: 'rgb(5 160 187)', border: 0 }} type="button">
                    yes
                  </Button>
                </ModalFooter>
              </Modal>
            </Card>
          </div>
        </Row>
      </Container>
      <Modal
        className="modal-dialog-centered"
        isOpen={open}
        size="lg"
        style={{ maxWidth: '700px', width: '100%' }}
      // onClick={handleClose}
      >
        <div onClick={handleClose} style={{ backgroundColor: 'rgb(193 193 125)', width: '30px', height: '30px', position: 'absolute', right: '-10px', top: '-10px', borderRadius: '50%' }}>
          <IcomoonReact iconSet={iconSet} onClick={handleClose} style={{ position: 'absolute', right: 10, top: 10 }} color="white" size={12} icon="close" />
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', backgroundColor: 'rgb(9 87 124)', paddingBottom: 20, color: 'white', paddingTop: 20 }}>EDIT USER</div>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={handleClose}
        >
          <IcomoonReact iconSet={iconSet} color="white" size={14} icon="close" />
        </button>
        <div>
          <Form
            onSubmit={onSubmit}
            validate={values => {
              const errors = {};
              function validateEmail(email) {
                var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
              }
              function validatePhone(phone) {
                var ph = /^(\d{8}(\,\d{8}){0,2})$/;
                return ph.test(String(phone).toLowerCase());
              }

              if (!values.full_name) {
                errors.full_name = "required";
              }
              if (!values.email) {
                errors.email = "required";
              } else if (!validateEmail(values.email)) {
                errors.email = "Enter a valid email address";
              }
              if (!values.phone) {
                errors.phone = "Required";
              } else if (!validatePhone(values.phone)) {
                errors.phone = "Enter a valid phonenumber";
              }
              if (!values.username) {
                errors.username = "required";
              }
              return errors;
            }}
            render={({ handleSubmit, values, submitting, validating, valid }) => (
              <form onSubmit={handleSubmit} style={{ padding: '10px' }}>
                <div className="pl-lg-4">
                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <Label for="full_name" style={{ fontSize: ' 0.8125rem' }}>Full Name</Label>
                        <Field name="full_name" initialValue={users[pos].full_name ? users[pos].full_name : null}>
                          {({ input, meta }) => (
                            <div>
                              <Input
                                type="text"
                                {...input}
                                placeholder="Enter User FullName"
                                style={{ color: 'black' }}
                                invalid={meta.error && meta.touched}
                              />
                              {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                            </div>
                          )}
                        </Field>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="4">
                      <FormGroup >
                        <Label style={{ fontSize: ' 0.8125rem' }} for="role">Roles</Label>
                        <Field name="role"  >
                          {({ input, meta, value }) => (
                            <div>
                              <Input defaultValue={users[pos]?.role} type="select" name="role" onChange={(e) => setSelectedrole(e.target.value)} style={{ color: 'black' }}>
                                <option value='admin'>Administrator</option>
                                <option value='suprevisor'>Suprevisor</option>
                              </Input>
                            </div>
                          )}
                        </Field>
                      </FormGroup>
                    </Col>
                    <Col lg="4">
                      <FormGroup>
                        <Label style={{ fontSize: ' 0.8125rem' }} for="email">E-mail</Label>
                        <Field name="email" initialValue={users[pos].email ? users[pos].email : null}>
                          {({ input, meta }) => (
                            <div>
                              <Input
                                {...input}
                                type="email"
                                style={{ color: 'black' }}
                                placeholder="Enter email address"
                                invalid={meta.error && meta.touched}
                              />
                              {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                            </div>
                          )}
                        </Field>
                      </FormGroup>
                    </Col>
                    <Col lg="4">
                      <FormGroup>
                        <Label style={{ fontSize: ' 0.8125rem' }} for="phone">Phone Number</Label>
                        <Field name="phone" initialValue={users[pos].phone ? users[pos].phone : null}>
                          {({ input, meta }) => (
                            <div>
                              <Input
                                {...input}
                                type="text"
                                style={{ color: 'black' }}
                                placeholder="Enter Phone Number"
                                invalid={meta.error && meta.touched}
                              />
                              {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                            </div>
                          )}
                        </Field>
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
                <div className="pl-lg-4">
                  <Row>
                    <Col lg="4">
                      <FormGroup>
                        <Label style={{ fontSize: ' 0.8125rem' }} for="username">User Name</Label>
                        <Field name="username" initialValue={users[pos].username ? users[pos].username : null}>
                          {({ input, meta }) => (
                            <div>
                              <Input
                                {...input}
                                type="text"
                                style={{ color: 'black' }}
                                placeholder="Enter UserName"
                                invalid={meta.error && meta.touched}
                              />
                              {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                            </div>
                          )}
                        </Field>
                      </FormGroup>
                    </Col>
                    <Col lg="4">
                      <FormGroup>
                        <Label style={{ fontSize: ' 0.8125rem' }} for="password">Password</Label>
                        <Field name="password">
                          {({ input, meta }) => (
                            <div>
                              <Input
                                {...input}
                                type="password"
                                style={{ color: 'black' }}
                                placeholder="Enter Password"
                              />
                            </div>
                          )}
                        </Field>
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
                <hr className="my-4" />
                <div style={{ paddingBottom: '30px', display: 'flex', justifyContent: 'center' }}>
                  <Button disabled={loading} color={'white'} type="submit" style={{ backgroundColor: '#09577C', marginLeft: 10, border: 0, color: 'white', width: '40%', borderRadius: '10px' }} >
                    {loading && (<Spinner as="span" size="sm" role="status" aria-hidden="true" style={{ marginRight: 20 }} />)}
                    UPDATE</Button>{' '}
                </div>
              </form>
            )}
          />
        </div>
      </Modal>
      <div >
        <Modal
          className="modal-dialog-centered"
          isOpen={view_open}
          size="lg"
          style={{ maxWidth: '700px', width: '100%' }}
        >
          <div onClick={viewClose} style={{ backgroundColor: 'rgb(193 193 125)', width: '30px', height: '30px', position: 'absolute', right: '-12px', top: '-10px', borderRadius: '50%', cursor: 'pointer' }}>
            <IcomoonReact iconSet={iconSet} onClick={viewClose} style={{ position: 'absolute', right: 10, top: 10 }} color="white" size={12} icon="close" />
          </div>
          <div style={{ textAlign: 'center', backgroundColor: '#09577C', padding: 15 }} >
            <h2 style={{ marginTop: '10px', marginLeft: 20, textAlign: 'center', color: 'white' }} className="modal-title" >
              VIEW USER
            </h2>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={viewClose}
            >
            </button>
          </div>
          <div style={{ padding: 10 }}>
            <div className="pl-lg-4" >
              <Row style={{ padding: 10 }}>
                <Col md="12">
                  <Label style={{ fontSize: ' 0.8125rem' }} >FullName</Label>
                  <Input
                    value={users[pos]?.full_name}
                    disabled
                    type="text"
                    style={{ color: 'black', backgroundColor: 'transparent' }}
                  />
                </Col>
              </Row>
              <Row style={{ padding: 10 }}>
                <Col md="4">
                  <Label style={{ fontSize: ' 0.8125rem' }} >Roles</Label>
                  <Input
                    value={users[pos]?.role}
                    disabled
                    type="text"
                    style={{ color: 'black', backgroundColor: 'transparent' }}
                  />
                </Col>
                <Col md="4">
                  <Label style={{ fontSize: ' 0.8125rem' }} >Email</Label>
                  <Input
                    value={users[pos]?.email ? users[pos]?.email : null}
                    disabled
                    type="text"
                    style={{ color: 'black', backgroundColor: 'transparent' }}
                  />
                </Col>
                <Col md="4">
                  <Label style={{ fontSize: ' 0.8125rem' }} >PhoneNumber</Label>
                  <Input
                    value={users[pos]?.phone ? users[pos]?.phone : null}
                    disabled
                    type="text"
                    style={{ color: 'black', backgroundColor: 'transparent' }}
                  />
                </Col>
              </Row>
              <Row style={{ padding: 10 }}>
                <Col md="4">
                  <Label style={{ fontSize: ' 0.8125rem' }} >UserName</Label>
                  <Input
                    value={users[pos]?.username ? users[pos]?.username : null}
                    disabled
                    type="text"
                    style={{ color: 'black', backgroundColor: 'transparent' }}
                  />
                </Col>
              </Row>
            </div>
            <div style={{ marginTop: 20, textAlign: 'center', marginBottom: 10 }}>
              <Button disabled={loading} onClick={viewClose} color={'white'} type="submit" style={{ backgroundColor: '#09577C', color: 'white', width: '40%', borderRadius: '10px', flex: 1, border: 0 }} >
                {loading && (<Spinner as="span" size="sm" role="status" aria-hidden="true" style={{ marginRight: 20 }} />)}
                DONE</Button>{' '}
            </div>

          </div>
        </Modal>
      </div>

      {/* confirm modal */}
      <Modal isOpen={sucess} size="sm">
        <ModalBody style={{ color: 'green' }}>Updated successfully!</ModalBody>
      </Modal>

      {/* session time out */}
      <Modal isOpen={modalOpen} size="sm">
        <div className=" modal-header"></div>
        <ModalBody style={{ backgroundColor: 'rgb(219 219 147)', color: 'red' }}>Your session has expired. Please sign in again.</ModalBody>
        <ModalFooter>
          <Button onClick={() => onLogout()} style={{ backgroundColor: '#09577C', color: 'white' }} type="button">
            LOGOUT
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={peropen} size="sm">
        <ModalBody style={{ color: 'red' }}>You have no acess to change it..!</ModalBody>
        <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: 20 }}>
          <Button onClick={() => permodalClose()} style={{ backgroundColor: 'red', color: 'white', border: 0 }}>Ok</Button>
        </div>
      </Modal>
    </>
  );
};

export default Users;
